var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApps2AddLine = function SvgApps2AddLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.083 7.833a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 0 0-7.5 0m0 8.334a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 0 0-7.5 0m8.334 0a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 0 0-7.5 0m-2.5-8.334a2.083 2.083 0 1 1-4.167 0 2.083 2.083 0 0 1 4.167 0m0 8.334a2.083 2.083 0 1 1-4.167 0 2.083 2.083 0 0 1 4.167 0m8.333 0a2.083 2.083 0 1 1-4.167 0 2.083 2.083 0 0 1 4.167 0m-2.917-5v-2.5h-2.5V7h2.5V4.5H17V7h2.5v1.667H17v2.5z"
  })));
};
export default SvgApps2AddLine;